<template>
  <v-card id="listener_aggiunta_riga_generale">
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">
        Dichiarazione di Produzione
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Bottone di salvataggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="salvaRigaGenerale" small v-bind="attrs" v-on="on">
            <v-icon color="success">mdi-floppy</v-icon>
          </v-btn>
        </template>
        <span>Salva Riga Generale</span>
      </v-tooltip>

      <!-- Bottone di aggiunta dichiarazione -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="ml-5"
            @click="aggiungiDichiarazione"
            :disabled="modalita == 'edit'"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary">mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Aggiungi Dichiarazione</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- Bottone di chiusura -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
            <v-icon color="error">mdi-close</v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text style="overflow-y: auto">
      <FormDichiarazione
        :ref="'FormDichiarazione' + i"
        :key="i"
        :riga_ori="dichiarazione"
        v-for="(dichiarazione, i) in items_dichiarazioni"
      >
      </FormDichiarazione>
    </v-card-text>

    <!-- Loader -->
    <v-overlay :value="caricamento_dati" absolute z-index="999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />

    <!-- Snackbar multipla -->
    <MultiSnackbarQV ref="MultiSnackbarQV" />
  </v-card>
</template>
<script>
import FormDichiarazione from "@/components/PRODUCTION/Avanzamento/FormDichiarazione.vue";
import moment from "moment";
import MultiSnackbarQV from "@/components/TOOLS/MultiSnackbarQV.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class CollateralePezzi {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "cod_commessa", default_val: "" },
      { nome: "cod_fase", default_val: "" },
      { nome: "cod_macchina", default_val: "" },
      { nome: "data", default_val: "" },
      { nome: "des_fase", default_val: "" },
      { nome: "id_articolo", default_val: null },
      { nome: "id_commessa", default_val: null },
      { nome: "id_commessa_dettaglio", default_val: null },
      { nome: "id_commessa_tempi", default_val: null },
      { nome: "id_macchina", default_val: null },
      { nome: "id_movimento", default_val: null },
      { nome: "id_personale", default_val: null },
      { nome: "nominativo", default_val: "" },
      { nome: "note", default_val: "" },
      { nome: "quantita", default_val: 0 },
      { nome: "riferimento", default_val: 0 },
      { nome: "tipo_record", default_val: null },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

class Causale {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "id_causale", default_val: null },
      { nome: "id_commessa_causale", default_val: -1 },
      { nome: "minuti", default_val: null },
      { nome: "pezzi", default_val: null },
      { nome: "tipo", default_val: null },
      { nome: "tipo_record", default_val: "" },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

export default {
  name: "AggiuntaRigaGenerale",
  components: { FormDichiarazione, MultiSnackbarQV, SnackbarQV },
  props: {
    modalita: {
      type: String,
      default: "",
    },
    riga_ori: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // Variabili d'appoggio

      // Modal
      caricamento_dati: false,

      // Array
      items_dichiarazioni: new Array(),
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    aggiungiDichiarazione() {
      this.items_dichiarazioni.push(
        JSON.parse(
          JSON.stringify(this.$refs.FormDichiarazione0[0].riga_generale)
        )
      );
    },
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    async salvaRigaGenerale() {
      const stack_request = new Array();
      let chk_dati_ok = true;

      for (let i = 0; i < this.items_dichiarazioni.length; i++) {
        const riga_generale =
          this.$refs["FormDichiarazione" + i][0].riga_generale;

        // Controllo che ci sia una commessa.
        if (
          riga_generale.id_commessa == null ||
          riga_generale.id_commessa === ""
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            `Selezionare una commessa per la dichiarazione ${i + 1}.`
          );
          chk_dati_ok = false;
          return;
        }

        // Controllo che ci sia una fase.
        if (riga_generale.id_fase == null || riga_generale.id_fase === "") {
          this.$refs.SnackbarQV.print(
            "orange",
            `Selezionare una fase per la dichiarazione ${i + 1}.`
          );
          chk_dati_ok = false;
          return;
        }

        // Controllo che ci sia una macchina.
        if (
          riga_generale.id_macchina == null ||
          riga_generale.id_macchina === ""
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            `Selezionare una macchina per la dichiarazione ${i + 1}.`
          );
          chk_dati_ok = false;
          return;
        }

        // Controllo che ci sia un'ora di start.
        if (riga_generale.ora_start == null || riga_generale.ora_start === "") {
          this.$refs.SnackbarQV.print(
            "orange",
            `Selezionare un'ora di start per la dichiarazione ${i + 1}.`
          );
          chk_dati_ok = false;
          return;
        }

        // Controllo che ci sia un'ora di stop.
        if (riga_generale.ora_stop == null || riga_generale.ora_stop === "") {
          this.$refs.SnackbarQV.print(
            "orange",
            `Selezionare un'ora di stop per la dichiarazione ${i + 1}.`
          );
          chk_dati_ok = false;
          return;
        }

        // Controllo che ci sia un addetto.
        if (
          riga_generale.id_personale == null ||
          riga_generale.id_personale === ""
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            `Selezionare il personale per la dichiarazione ${i + 1}.`
          );
          chk_dati_ok = false;
          return;
        }

        // Controllo la coerenza delle date e delle ore.
        if (
          moment(
            `${riga_generale.data_start} ${riga_generale.ora_start}`
          ).isAfter(
            moment(`${riga_generale.data_stop} ${riga_generale.ora_stop}`)
          )
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            `I momenti di start e stop sono incompatibili per la dichiarazione ${
              i + 1
            }.`
          );
          chk_dati_ok = false;
          return;
        }

        // Prendo da parte i pezzi.
        const pezzi_ok_tmp = new Array();

        this.$refs["FormDichiarazione" + i][0].items_pezzi_ok
          .filter((elem) => elem.validita == 1 || elem.id_movimento > 0)
          .forEach((elem) => {
            const elem_tmp = new CollateralePezzi(elem);

            /* Questo postulato condizionale serve per evitare di portare
             * a nulla la data in commessa_movimenti nell'esecuzione della
             * logica di salvataggio nel BE. */
            if (elem._ora != null && elem._ora != "") {
              elem_tmp.data = `${elem._ora.substr(6, 4)}-${elem._ora.substr(
                3,
                2
              )}-${elem._ora.substr(0, 2)} ${elem._ora.substr(11, 8)}`;
            }

            elem_tmp.id_commessa_tempi = riga_generale.id_commessa_tempi;
            elem_tmp.id_commessa_movimenti = elem_tmp.id_movimento;

            if (elem_tmp.id_commessa_movimenti < 0) {
              elem_tmp.id_commessa_movimenti = -1;
            }

            pezzi_ok_tmp.push(elem_tmp);
          });

        // Prendo da parte i fermi.
        const items_fermi_tmp = new Array();

        this.$refs["FormDichiarazione" + i][0].items_fermi
          .filter((elem) => elem.validita == 1 || elem.id_commessa_causale > 0)
          .forEach((elem) => {
            const elem_tmp = new Causale(elem);
            elem_tmp.id_commessa_tempi = riga_generale.id_commessa_tempi;
            elem_tmp.tipo_causale = "FERMO";
            if (elem_tmp.id_commessa_causale < 0) {
              elem_tmp.id_commessa_causale = -1;
            }

            items_fermi_tmp.push(elem_tmp);
          });

        // Prendo da parte gli scarti.
        const items_scarti_tmp = new Array();

        this.$refs["FormDichiarazione" + i][0].items_scarti
          .filter((elem) => elem.validita == 1 || elem.id_commessa_causale > 0)
          .forEach((elem) => {
            const elem_tmp = new Causale(elem);
            elem_tmp.id_commessa_tempi = riga_generale.id_commessa_tempi;
            elem_tmp.tipo_causale = "SCARTO";
            if (elem_tmp.id_commessa_causale < 0) {
              elem_tmp.id_commessa_causale = -1;
            }

            items_scarti_tmp.push(elem_tmp);
          });

        // Preparo la request (ma non la mando ancora).
        const request = {
          controller: "Magazzino",
          method: "PUT",
          richiesta: {
            action: "addconsuntivogenerale",
            token: localStorage.user_token,
            tempi: [
              {
                id_commessa_tempi: riga_generale.id_commessa_tempi,
                id_causale: 55,
                id_personale: riga_generale.id_personale,
                id_commessa: riga_generale.id_commessa,
                id_commessa_dettaglio: riga_generale.id_commessa_dettaglio,
                id_macchina: riga_generale.id_macchina,
                data: `${riga_generale.data_start} ${riga_generale.ora_start}`,
                ora_inizio: `${riga_generale.data_start} ${riga_generale.ora_start}`,
                ora_fine: `${riga_generale.data_stop} ${riga_generale.ora_stop}`,
                id_turno: riga_generale.id_turno,
              },
            ],
            pezzi: pezzi_ok_tmp,
            scarti: items_scarti_tmp,
            fermi: items_fermi_tmp,
          },
        };

        // Se sto salvando una riga nuova registro che è aggiunta a mano.
        if (riga_generale.id_commessa_tempi < 0) {
          request.richiesta.tempi[0].tipo_record = "M";
        }

        // Aggiungo la request allo stack di invio.
        stack_request.push(request);
      }

      /* Se tutti i controlli di tutte le dichiarazioni sono ok,
       * mando una per volta tutte le richieste dello stack di invio.*/
      if (chk_dati_ok === true) {
        this.caricamento_dati = true;
        this.dispatchStackChiamate(stack_request, 0, 0);
      }
    },
    dispatchStackChiamate(arr, idx, errori) {
      this.$store
        .dispatch("api", arr[idx])
        .then((res) => {
          if (res.status == 200) {
            // Se la response è ok, elimino il form dall'interfaccia.
            this.items_dichiarazioni.splice(idx, 1);
          } else {
            errori++;
            this.$refs.MultiSnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }

          /* Decido se devo stoppare l'overlay di
           * caricamento o continuare con le chiamate. */
          if (idx >= arr.length - 1) {
            this.caricamento_dati = false;

            if (errori == 0) {
              this.$emit("salvata_riga");
            }
          } else {
            this.dispatchStackChiamate(arr, idx + 1, errori);
          }
        })
        .catch((err) => {
          errori++;

          // Segno una richiesta da inviare in meno e una spanata in più.
          console.error(err);
          this.$refs.MultiSnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );

          // Decido se devo stoppare l'overlay di caricamento.
          if (idx >= arr.length - 1) {
            this.caricamento_dati = false;
          } else {
            this.dispatchStackChiamate(arr, idx + 1, errori);
          }
        });
    },
  },
  created() {},
  mounted() {
    this.items_dichiarazioni.push(this.riga_ori);
  },
};
</script>
<style scoped>
</style>